import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wrapper-banners" }
const _hoisted_2 = { class: "above-info" }
const _hoisted_3 = { class: "wrapper-banners" }
const _hoisted_4 = { class: "banner-number" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_StandardButton = _resolveComponent("StandardButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalConfirmation, {
      message: _ctx.confirmMessage,
      onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeConfirmModalAsync(_ctx.deleteBannerTransaction))),
      onDeny: _ctx.closeConfirmModalAsync
    }, null, 8, ["message", "onDeny"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "Banners", -1)),
        _createElementVNode("input", {
          type: "file",
          ref: "fileReference",
          hidden: "",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createBannerTransaction && _ctx.createBannerTransaction(...args))),
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($event.target.value = ''))
        }, null, 544),
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Crear banner',
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.fileReference.click()))
        })
      ]),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (banner, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "banner",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, "Banner " + _toDisplayString(index + 1), 1)
            ]),
            _createVNode(_component_DeleteButton, {
              onClick: ($event: any) => (_ctx.selectDeletedBanner(banner)),
              type: 'Delete'
            }, null, 8, ["onClick"]),
            _createElementVNode("img", {
              src: banner.path,
              class: "banner-image"
            }, null, 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}